import { render, staticRenderFns } from "./CampaignRuleConfig.vue?vue&type=template&id=6c5390e2&"
import script from "./CampaignRuleConfig.vue?vue&type=script&lang=js&"
export * from "./CampaignRuleConfig.vue?vue&type=script&lang=js&"
import style0 from "./CampaignRuleConfig.vue?vue&type=style&index=0&id=6c5390e2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports